import React from 'react';
import Card from '@material-ui/core/Card';
import StarIcon from '@material-ui/icons/StarTwoTone';
import EditIcon from '@material-ui/icons/EditTwoTone';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import { withStyles } from '@material-ui/core/styles';
import PromotionEditor from './PromotionEditor';
import Chip from '@material-ui/core/Chip';
import get from 'lodash/get';
import { Map } from 'immutable';
import Promise from 'bluebird';
import { Storage } from 'aws-amplify';
import ImageWithPreview from '../ImageWithPreview';
import PrivateBlock from '../PrivateBlock';
import useIsAllowed from '../../hooks/useIsAllowed';
import PhotoCatalog from '../PhotoCatalog';

const styles = themes => ({
  root: { test: 1 },
  card: {
    minWidth: 275,
  },
  bullet: {
    display: 'inline-block',
    margin: '0 2px',
    transform: 'scale(0.8)',
  },
  title: {
    fontSize: 14,
  },
  pos: {
    marginBottom: 12,
  },
  star: {
    float: 'left',
    color: 'gold',
    marginTop: 5,
  },
  desc: {
    whiteSpace: 'pre-line',
  },
  body: { marginLeft: 30 },
});

export default withStyles(styles)(function(props) {
  const {
    classes,
    editing: defaultEditing,
    promotion = {},
    showStoreType,
    enableAttachments,
  } = props;
  const [state, setState] = React.useState(Map({ photoUrls: [], loading: true }));
  const editing = state.get('editing', defaultEditing);

  const onEdit = React.useCallback(() => {
    setState(oldState => oldState.set('editing', true));
  }, []);

  const isAdmin = useIsAllowed({ allowedGroups: ['Admins'] });
  const isManager = useIsAllowed({ allowedGroups: ['Management'] });

  React.useEffect(() => {
    (async function() {
      const pFiles = get(promotion, 'files', []) || [];
      let s3Files = [];
      if (pFiles.length > 0) {
        s3Files = await Promise.map(pFiles, async pFile => {
          const url = await Storage.get(pFile.filename);
          return { name: pFile.filename, url };
        });
      }
      setState(oldState => oldState.set('loading', false).set('photoUrls', s3Files));
    })();
  }, [promotion.files]);

  if (editing) {
    const editorProps = {
      ...props,
      editing: true,
      onClose() {
        setState(oldState => oldState.set('editing', false));
        props.onClose && props.onClose();
      },
    };
    return <PromotionEditor {...editorProps} />;
  }

  // const canEdit = isAdmin || (isManager && promotion.type === 'STORE_PROMOTION');
  const canEdit = isAdmin || isManager;

  return (
    <div>
      <div className={classes.star}>
        <StarIcon />
      </div>
      <div className={classes.body}>
        <Typography variant="h5" component="h2">
          {promotion.name}
          {canEdit && (
            <IconButton color="primary" onClick={onEdit}>
              <EditIcon />
            </IconButton>
          )}
        </Typography>
        {/* <Typography className={classes.pos} color="textSecondary">
          adjective
        </Typography> */}
        <Typography component="p" className={classes.desc}>
          {promotion.description}
        </Typography>
        {showStoreType && <Chip label={promotion.storeType} />}
        {enableAttachments && <PhotoCatalog photoUrls={state.get('photoUrls')} />}
      </div>
    </div>
  );
});
